/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_Blocked_BodyInputs */



/**
* | output |
* | --- |
* | "The meeting is only open to certain participants, so Wundo could not join." |
*
* @param {Meeting_Notetaker_Issue_Blocked_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_blocked_body = /** @type {((inputs?: Meeting_Notetaker_Issue_Blocked_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Blocked_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De meeting staat alleen open voor bepaalde deelnemers, dus Wundo kon niet aansluiten.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("La réunion n'est ouverte qu'à certains participants, donc Wundo n'a pas pu la rejoindre.")
	return /** @type {LocalizedString} */ ("The meeting is only open to certain participants, so Wundo could not join.")
});